import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import Loading from "./Loading";
import Section from "./Section";
import SectInside from "./SectionTree"
import {StoreContext} from "../stores/contexts";

class SectionTree extends Component {
  static contextType = StoreContext;

  componentDidMount() {
    this.context.treeStore.loadTree(this.props.section);
  }
  isFetching() {
    if(this.context.treeStore.loaded_tree[this.props.section]) {
      const cur = this.context.treeStore.loaded_tree[this.props.section];
      if (cur.fetching) {
        return true;
      }
    }
    return false;
  }
  renderTree() {
    if(this.context.treeStore.loaded_tree[this.props.section]) {
      const cur=this.context.treeStore.loaded_tree[this.props.section];
      if(cur.fetching && !cur.data) {
        return <Loading />
      } else {
        const items=[];
        if(this.props.section == "0") {
          items.push(
            <div key={'all'}>
              <Section level={1}  item={{ id:'all',section:0, disable_drag:true, disable_drop:true, [this.context.treeStore.par.name_field]:'Все' }} />
            </div>
          );
          items.push(
            <div key={'root'}>
              <Section level={1}  item={{ id:'root',section:0, disable_drag:true, [this.context.treeStore.par.name_field]:'В корне'}} />
            </div>
          );
        }
        if(cur.data.items) {
          cur.data.items.map((item)=>{
            items.push(
              <div key={item.id}>
                <Section  item={item} level={this.props.level} />
              </div>
            );
          });
        }
        return (
          <div>
            {items}
          </div>
        )
      }
    }
    return null;
  }
  renderLoadMore() {
    if(this.context.treeStore.show_more[this.props.section]) {
      return (
        <div className="pleft15">
          <div onClick={()=>{ this.context.treeStore.loadTree(this.props.section,true); }} className="pointer mbottom10 bg-w5-hover hpadd20 bg-w4 rad3 b1 vpadd5 tac mright15">
            Еще
          </div>
        </div>
      )
    }
    return null;
  }
  render() {
    return (
      <div style={{paddingLeft:0}} className={` ${this.isFetching()?'transp50':''} pr`}>
        {this.renderTree()}
        {this.renderLoadMore()}
      </div>
    )
  }
}

// export default inject("treeStore")(observer(SectionTree));
export default observer(SectionTree);